import { useContext, useEffect, useState } from "react";
import ContextFlujos from "../Context/ContextFlujos";
import { Col, Container, Row } from "react-bootstrap";
import styles from '../BlueToGo/BlueToGo.module.css';
import BlueToGoInicio from "../BlueToGo/BlueToGoInicio";
import { Link, useNavigate } from "react-router-dom";
import { activacionBlueToGo, consultaLDAP, consultaSolicitudServicio } from "../BlueToGo/servicios";
import { Atributo } from "../Commons/Services/ConsultarLDAP";
import { DetalleSolicitudDeServicio } from "../Commons/Services/ConsultaSolicitudDeServicioRest";



const BlueToGo = () => {
  const { setSkyPlus, setSkyCelular, pais, setPais, setDTHSkyPlus } = useContext(ContextFlujos) as any;

  const [determinaContratacion, setDeterminaContratacion] = useState(false);

  const navigate = useNavigate();

  const determinaBlueContratado = async () => {

    const respuestaSolicitud = await consultaSolicitudServicio();

    if (respuestaSolicitud.ConsultaSolicitudDeServicioProcessResponse.DetalleSolicitudDeServicio?.length > 0) {

      const arregloSolicitud = respuestaSolicitud.ConsultaSolicitudDeServicioProcessResponse.DetalleSolicitudDeServicio;

      arregloSolicitud.forEach((item: DetalleSolicitudDeServicio) => {

        let comentario: string = item.Comentario!;
        comentario = comentario.toUpperCase();
        let validaCadena: boolean = comentario.includes("BLUETOGOVIDEOEVERYWHERE");

        let estado: string = item.Estatus!;
        estado = estado.toUpperCase();
        let validaCadenaEstatus: boolean = estado.includes("CERRADO");

        if (validaCadena && validaCadenaEstatus) {
          setDeterminaContratacion(true);
        }
      });

    }

    if (determinaContratacion === true) {
      navigate("/bluetogoactivacion");
    }


    if (determinaContratacion === false) {

      const respuestaLDAP = await consultaLDAP();
      const arregloLDAP = respuestaLDAP.Atributos;

      if (arregloLDAP.length > 0) {

        arregloLDAP.forEach(async (item: Atributo) => {
          if (item.ValorAtributo === "C_BTG") {
            setDeterminaContratacion(true);
          }
        });
      }
    }
  }



  useEffect(() => {
     if (sessionStorage.getItem("flujos") === "Sky+") {
         setSkyPlus({estado:false});
         setDTHSkyPlus({ estado: false });

       }

       if (sessionStorage.getItem("flujos") ===  "DTH/SkyCelular" || sessionStorage.getItem("flujos") ===  "DTH/DTH/SkyCelular/Sky+") {
         setSkyCelular({estado:true});
       }

       if (sessionStorage.getItem("flujos") ===  "DTH/Sky+" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular/Sky+") {
        setDTHSkyPlus({estado:false});
      }
  
      if (sessionStorage.getItem("flujos") ===  "DTH" || sessionStorage.getItem("flujos") ===  "DTH/SkyCelular") {
        setDTHSkyPlus({estado:true});
      }

       setPais(sessionStorage.getItem("pais"));

    determinaBlueContratado();

  }, []);

  return (
    <>
      <Container className={styles["containerPagina"]}>

        <Row>
          <Col>
            {determinaContratacion ? <h2 className={styles.tituloPagina}>Bienvenido a la nueva era de la TV</h2> : <h2 className={styles.tituloPagina}>Contrata Blue To Go ahora es Sky+</h2>}
          </Col>

        </Row>
        <BlueToGoInicio statusContratacion={determinaContratacion} />
      </Container>

    </>
  );

};

export default BlueToGo;
